import { LitElement, css, html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";

import { getIcon } from "./icon.helpers";

import type { PropertyValues } from "lit";

export type IconSizeAttribute = "sm" | "md" | "lg" | "xl" | "2xl";

@customElement("bp-icon")
export class Icon extends LitElement {
  static styles = css`
    :host {
      display: inline-flex;
      fill: var(--icon-color, currentColor);
      height: var(--icon-size, var(--size-2-5));
      width: var(--icon-size, var(--size-2-5));
    }

    :host([size="sm"]) {
      --icon-size: var(--size-2);
    }

    :host([size="lg"]) {
      --icon-size: var(--size-3);
    }

    :host([size="xl"]) {
      --icon-size: var(--size-4);
    }

    :host([size="2xl"]) {
      --icon-size: var(--size-5);
    }

    svg {
      display: block;
      width: 100%;
      height: 100%;
    }
  `;

  @property()
  icon?: string;

  @property()
  size?: IconSizeAttribute;

  @state()
  xml?: string;

  updated(changedProperties: PropertyValues<this>) {
    if (!changedProperties.has("icon") || !this.icon) return;

    getIcon(this.icon).then((xml) => {
      this.xml = xml;
    });
  }

  render() {
    if (this.xml) {
      return unsafeHTML(this.xml);
    }

    return html` <slot></slot> `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-icon": Icon;
  }
}
